import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_VMS_AZURE_IMAGES,
  GET_VMS_AZURE_IMAGES_SUCCESS,
  GET_VMS_AZURE_IMAGES_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureVmsImagesList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureVmsImagesStore(state = initialState, action) {
  switch (action.type) {
    case GET_VMS_AZURE_IMAGES:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_VMS_AZURE_IMAGES_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureVmsImagesList: action.data,
        error: null,
      };
    case GET_VMS_AZURE_IMAGES_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
